import React, { useEffect, useState } from 'react'
import Header from './Header'

//  css file 
import "./masters.css"

// images start 
import Lexile_rubric from "../assets/Lexile_rubric.png"


//icons
import { SiGoogleclassroom } from "react-icons/si";
import { BsSignIntersectionY } from "react-icons/bs";
import { MdClose } from "react-icons/md";
import { MdOutlineAddLocationAlt, MdCalendarMonth } from "react-icons/md";
import { BiSolidCircleThreeQuarter } from "react-icons/bi";
import { FaChartArea } from "react-icons/fa";

//icons
import { IoMdClose, IoMdReturnRight } from "react-icons/io";
import { FaEdit } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import { GrVirtualStorage } from "react-icons/gr";
import { MdOutlineSettingsInputComponent } from "react-icons/md";


// material ui components start 
// import * as React from 'react';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';



import axios from 'axios';
import { API } from './constant';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

const names = [
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'I',
    'J',
    'K',
    'L',
    'M',
];
// material ui components end



const Masters = () => {
    const [showModalClass, setshowModalClass] = useState(false)
    const [showModalSection, setshowModalSection] = useState(false)
    const [showModalLocation, setshowModalLocation] = useState(false)
    const [createSession, setcreateSession] = useState(false)
    const [createQuarter, setcreateQuarter] = useState(false)
    const [updateTable, setupdateTable] = useState(false)
    const [showRubric, setShowRubric] = useState(false)

    // ======================= class operation start ==============================
    // -----------create class start ----------------
    const [class_name, setclass_name] = useState("")
    const handleCreateClass = async () => {
        const data = {
            name: class_name
        }
        await axios.post(`${API}/create-class`, data, {
            headers: {
                "Content-Type": "application/json",
                "token": localStorage.getItem("token")
            }
        })
            .then((res) => {
                // console.log(res)
                alert(res.data.message)
                setupdateTable(!updateTable)
                clearfields()
            })
            .catch((err) => {
                console.log(err)
            })
    }
    //----------- create class end------------------

    // --------------get all class data start ----------
    const [allClassDATA, setallClassDATA] = useState([])
    useEffect(() => {
        axios.get(`${API}/create-class`)
            .then((res) => {
                // console.log(res)
                setallClassDATA(res.data.data)
            })
            .catch((err) => {
                console.log(err)
            })
    }, [updateTable])
    // ------------get all class data end------------

    // ------------edit class data start -----------
    const [EditClassModal, setEditClassModal] = useState("")
    const [selectedRowData, setselectedRowData] = useState("")
    const [editClassName, seteditClassName] = useState("")

    const handleEditClass = (item) => {
        setEditClassModal(true)
        setselectedRowData(item)
    }
    const editClass = (id) => {
        const data = {
            name: editClassName
        }
        axios.put(`${API}/create-class/${id}`, data, {
            headers: {
                "Content-Type": "application/json",
                "token": localStorage.getItem("token")
            }
        })
            .then((res) => {
                // console.log(res)
                alert(res.data.message)
                setupdateTable(!updateTable)
                setEditClassModal(false)


            })
            .catch((err) => {
                console.log(err)
            })
    }
    // ------------edit class data end--------------

    // -----------delete class start ----------------
    const [deletePopUp, setdeletePopUp] = useState(false)
    const [DeleteId, setDeleteId] = useState(false)

    const handledeletePopUp = (id) => {
        setdeletePopUp(true)
        setDeleteId(id)
    }

    const handleDelete = (id) => {
        axios.delete(`${API}/create-class/${id}`)
            .then((res) => {
                console.log(res)
                // alert(res.data.message)
                setdeletePopUp(false)
                setupdateTable(!updateTable)

            })
            .catch((err) => {
                console.log(err)
            })

    }
    // -----------delete class end-----------------
    // ======================= class operation end=================================


    
    //============= ============find user role and give permission start ============================
    const [loggedinRole, setLoggedinRole] = useState("")
    useEffect(() => {
        axios.get(`${API}/login/logged-in-user`, {
            headers: {
                "Content-Type": "application/json",
                "token": localStorage.getItem("token")
            }
        })
            .then((res) => {
                setLoggedinRole(res.data.data.role)
            })
            .catch((err) => {
                // console.log(err);
                if (err.response) {
                    // Handle invalid token
                    if (err.response.status === 401) {
                        localStorage.removeItem("token");
                        // history.push('/');
                        window.location.href = "/"
                    }
                    // Handle token expiration
                    else if (err.response.status === 302) {
                        window.location.href = "/"

                    }
                }
            });
    }, [])

    //============= ============find user role and give permission end ============================



    // ======================= section operation start=================================
    // handle search class start
    //  const [SearchClass, setSearchClass] = useState("")
    //  const [SearchSection, setSearchSection] = useState([])
    //  const [classSections, setclassSections] = useState({})

    //  useEffect(() => {
    //      fetchData()
    //  }, [])
    //  const fetchData = async () => {
    //      try {
    //          const response = await axios.get(`${API}/upload`);
    //          const fetchedData = response.data.data;
    //          const classSectionsMap = fetchedData.reduce((acc, item) => {
    //              if (!acc[item.class]) {
    //                  acc[item.class] = new Set()
    //              }
    //              acc[item.class].add(item.section)
    //              return acc
    //          }, {})

    //          //  converts sets to arrays 
    //          for (let cls in classSectionsMap) {
    //              classSectionsMap[cls] = Array.from(classSectionsMap[cls]);
    //          }
    //          setclassSections(classSectionsMap)
    //      } catch (error) {

    //      }
    //  }
    //  const handleSearchClass = (event) => {
    //      setSearchClass(event.target.value)
    //      setSearchSection("")
    //  }

    //  const handleSearchSection=(event)=>{
    //      setSearchSection(event.target.value)
    //  }
    // handle search class end

    //------------ submit section start ----------------
    const [classNameforSection, setClassNameforSection] = React.useState("");
    const [sectionName, setSectionName] = React.useState([]);

    const handleChange = (event) => {
        const {
            target: { value },
        } = event;
        setSectionName(
            // On autofill we get a stringified value.
            typeof value === 'string' ? value.split(',') : value,
        );
    };


    const handleSubmitSection = async () => {
        const data = {
            class_name: classNameforSection,
            sections: sectionName
        }
        await axios.post(`${API}/create-section`, data,{
            headers: {
                "Content-Type": "application/json",
                "token": localStorage.getItem("token")
            }
        })
            .then((res) => {
                console.log(res)
                alert(res.data.message)
                clearfields()
                setupdateTable(!updateTable)
                setshowModalSection(false)
            })
            .catch((err) => {
                console.log(err)
                alert(err.response.data.message)

            })
    }
    //------------ submit section start ----------------



    //------------ get section start ----------------
    const [get_section, setget_section] = useState([])
    // console.log(get_section)
    useEffect(() => {
        axios.get(`${API}/create-section`,{
            headers: {
                "Content-Type": "application/json",
                "token": localStorage.getItem("token")
            }
        })
            .then((res) => {
                // console.log(res.data.data)
                setget_section(res.data.data)
            })
            .catch((err) => {
                console.log(err)
            })
    }, [updateTable])
    //------------ get section end ----------------


    // ----------edit section start ---------------
    const [editshowModalSection, seteditshowModalSection] = useState(false)
    const [editclassNameforSection, seteditClassNameforSection] = React.useState("");
    const [editsectionName, seteditSectionName] = React.useState([]);
    const [editsectionID, seteditsectionID] = useState("")

    const handleEditSection = async (id) => {
        seteditshowModalSection(true)
        seteditsectionID(id)

        await axios.get(`${API}/create-section/${id}`,{
            headers: {
                "Content-Type": "application/json",
                "token": localStorage.getItem("token")
            }
        })
            .then((res) => {
                console.log(res.data.data)
                seteditClassNameforSection(res.data.data.class_name)
                seteditSectionName(res.data.data.sections)
            })
            .catch((err) => {
                console.log(err)
            })
    }

    const handleEditSubmitSection = async (id) => {

        const data = {
            class_name: editclassNameforSection,
            sections: editsectionName
        }

        await axios.put(`${API}/create-section/${id}`, data,{
            headers: {
                "Content-Type": "application/json",
                "token": localStorage.getItem("token")
            }
        })
            .then((res) => {
                // console.log(res.data.data.message)
                seteditshowModalSection(false)
                setupdateTable(!updateTable)
            })
            .catch((err) => {
                console.log(err)
            })

    }


    const handleEditChange = (event) => {
        const {
            target: { value },
        } = event;
        seteditSectionName(
            // On autofill we get a stringified value.
            typeof value === 'string' ? value.split(',') : value,
        );
    };
    // ----------edit section end ---------------



    // -----------delete section start ------------------
    const [deleteSectionPopUp, setdeleteSectionPopUp] = useState(false)
    const [DeleteSectionId, setDeleteSectionId] = useState("")


    const handledeleteSectionPopUp = (id) => {
        setdeleteSectionPopUp(true)
        setDeleteSectionId(id)
    }

    const handleDeleteSection = (id) => {
        axios.delete(`${API}/create-section/${id}`,{
            headers: {
                "Content-Type": "application/json",
                "token": localStorage.getItem("token")
            }
        })
            .then((res) => {
                console.log(res)
                // alert(res.data.message)
                setdeleteSectionPopUp(false)
                setupdateTable(!updateTable)

            })
            .catch((err) => {
                console.log(err)
            })

    }

    // -----------delete section end ------------------




    // ======================= section operation end=================================




    // =========================school location start ================================
    // -----------create school location start -------------
    const [school_location, setschool_location] = useState("")
    const handleCreateSchoolLOCATION = async () => {
        const data = {
            name: school_location
        }
        await axios.post(`${API}/school-location`, data, {
            headers: {
                "Content-Type": "application/json",
                "token": localStorage.getItem("token")
            }
        })
            .then((res) => {
                // console.log(res)
                alert(res.data.message)
                setupdateTable(!updateTable)
                clearfields()
            })
            .catch((err) => {
                console.log(err)
            })
    }
    // -----------create school location star end -------------

    // ----------get all school location start -----------
    const [allLocationData, setallLocationData] = useState([])
    useEffect(() => {
        axios.get(`${API}/school-location`)
            .then((res) => {
                // console.log(res)
                setallLocationData(res.data.data)
            })
            .catch((err) => {
                console.log(err)
            })
    }, [updateTable])
    // ----------get all school location end-----------

    // ------------edit school location start -----------------
    const [EditSchoolLocationModal, setEditSchoolLocationModal] = useState("")
    const [selectedRowDataSchool, setselectedRowDataSchool] = useState("")
    const [editschoolLocation, seteditschoolLocation] = useState("")

    const handleEditSchoolLocationpop = (item) => {
        setEditSchoolLocationModal(true)
        setselectedRowData(item)
    }
    const handleeditSchoolLocation = (id) => {
        const data = {
            name: editschoolLocation
        }
        axios.put(`${API}/school-location/${id}`, data, {
            headers: {
                "Content-Type": "application/json",
                "token": localStorage.getItem("token")
            }
        })
            .then((res) => {
                // console.log(res)
                alert(res.data.message)
                setupdateTable(!updateTable)
                setEditSchoolLocationModal(false)


            })
            .catch((err) => {
                console.log(err)
            })
    }
    // ------------edit school location end -----------------

    // -----------------delete shcool locatio start --------------------
    const [deletePopUpLocationModal, setdeletePopUpLocationModal] = useState(false)
    const [DeleteIdLocation, setDeleteIdLocation] = useState(false)

    const handledeletePopUpLocation = (id) => {
        setdeletePopUpLocationModal(true)
        setDeleteIdLocation(id)
    }

    const handleDeleteLocation = (id) => {
        axios.delete(`${API}/school-location/${id}`,{
            headers:{
                "Content-Type": "application/json",
                "token": localStorage.getItem("token")
            }
        })
            .then((res) => {
                console.log(res)
                // alert(res.data.message)
                setdeletePopUpLocationModal(false)
                setupdateTable(!updateTable)

            })
            .catch((err) => {
                console.log(err)
            })

    }
    // -----------------delete shcool locatio end --------------------


    // =========================school location end ================================








    // ===================== operation on session start ==========================
    // ----------create session start ---------------
    const [sessionName, setsessionName] = useState("")
    const handleCreateSession = async () => {
        const data = {
            name: sessionName
        }
        await axios.post(`${API}/session`, data, {
            headers: {
                "Content-Type": "application/json",
                "token": localStorage.getItem("token")
            }
        })
            .then((res) => {
                // console.log(res)
                alert(res.data.message)
                setupdateTable(!updateTable)
                clearfields()
            })
            .catch((err) => {
                console.log(err)
            })
    }
    // ----------create session end ---------------


    // ---------get all session data start ----------
    const [allsessiondata, setallsessiondata] = useState([])
    useEffect(() => {
        axios.get(`${API}/session`)
            .then((res) => {
                // console.log(res)
                setallsessiondata(res.data.data)
            })
            .catch((err) => {
                console.log(err)
            })
    }, [updateTable])
    //----------- get all session data end-----------

    // -------------edit session data start -------------
    const [editsessionModal, seteditsessionModal] = useState("")
    const [selectedRowDataSession, setselectedRowDataSession] = useState("")
    const [editSessionName, seteditSessionName] = useState("")

    const handleEditsessionPop = (item) => {
        seteditsessionModal(true)
        setselectedRowData(item)
    }
    // console.log(selectedRowData)

    const handleeditsession = (id) => {
        const data = {
            name: editSessionName
        }
        axios.put(`${API}/session/${id}`, data, {
            headers: {
                "Content-Type": "application/json",
                "token": localStorage.getItem("token")
            }
        })
            .then((res) => {
                // console.log(res)
                alert(res.data.message)
                setupdateTable(!updateTable)
                seteditsessionModal(false)


            })
            .catch((err) => {
                console.log(err)
            })
    }
    // -------------edit session data end -------------

    // delete session start 
    const [deletePopSession, setdeletePopSession] = useState(false)
    const [deletePopSESSIONid, setdeletePopSESSIONid] = useState(false)

    const HandlePOPsession = (id) => {
        setdeletePopSession(true)
        setdeletePopSESSIONid(id)
    }

    const handleDeletesession = (id) => {
        axios.delete(`${API}/session/${id}`,{
            headers:{
                "Content-Type": "application/json",
                "token": localStorage.getItem("token")
            }
        })
            .then((res) => {
                // console.log(res)
                // alert(res.data.message)
                setdeletePopSession(false)
                setupdateTable(!updateTable)

            })
            .catch((err) => {
                console.log(err)
            })

    }
    // delete session end

    // ===================== operation on sessionend ==========================





    // ===================================Operation on quarter start ===========================================
    // -------- create quarter start ------
    const [quarterName, setquarterName] = useState("")

    const handleCreateQuarter = async () => {
        const data = {
            name: quarterName
        }
        await axios.post(`${API}/quarter`, data, {
            headers: {
                "Content-Type": "application/json",
                "token": localStorage.getItem("token")
            }
        })
            .then((res) => {
                // console.log(res)
                alert(res.data.message)
                setupdateTable(!updateTable)
                clearfields()
            })
            .catch((err) => {
                // console.log(err)
                alert(err.response.data.message)
            })
    }
    //  --------create quarter end-------------

    //-------- get all quarter data start -------------
    const [quarterData, setquarterData] = useState([])
    useEffect(() => {
        axios.get(`${API}/quarter`)
            .then((res) => {
                // console.log(res)
                setquarterData(res.data.data)
            })
            .catch((err) => {
                console.log(err)
            })
    }, [updateTable])
    //-------- get all quarter data end -------------

    //----------- edit quarter start --------------
    const [editquarterModal, seteditquarterModal] = useState(false)
    // const [selectedRowDataSession, setselectedRowDataSession] = useState("")
    const [editQuarterName, seteditQuarterName] = useState("")

    const handleEditQuarterPop = (item) => {
        seteditquarterModal(true)
        setselectedRowData(item)
    }
    const handleeditquarter = (id) => {
        const data = {
            name: editQuarterName
        }
        axios.put(`${API}/quarter/${id}`, data, {
            headers: {
                "Content-Type": "application/json",
                "token": localStorage.getItem("token")
            }
        })
            .then((res) => {
                // console.log(res)
                alert(res.data.message)
                setupdateTable(!updateTable)
                seteditquarterModal(false)
            })
            .catch((err) => {
                console.log(err)
                alert(err.response.data.message)
            })
    }
    //------------ edit quarter end ------------

    // --------------delte quarter start -----------------
    const [deletePopQuarter, setdeletePopQuarter] = useState(false)
    const [deletePopQuarterid, setdeletePopQuarterid] = useState(false)

    const HandlePOPQuarter = (id) => {
        setdeletePopQuarter(true)
        setdeletePopQuarterid(id)
    }

    const handleDeletequarter = (id) => {
        axios.delete(`${API}/quarter/${id}`,{
            headers:{
                "Content-Type": "application/json",
                "token": localStorage.getItem("token")
            }
        })
            .then((res) => {
                console.log(res)
                // alert(res.data.message)
                setdeletePopQuarter(false)
                setupdateTable(!updateTable)

            })
            .catch((err) => {
                console.log(err)
            })

    }
    // --------------delte quarter end -----------------
    // ================================Operation on quarter end====================================



    // ====================operation on student age start =============================
    // ----------create student age start ----------
    const [studentAgeModal, setstudentAgeModal] = useState(false)
    const [studentAge, setstudentAge] = useState("")

    const handleCreateStudentAge = async () => {
        const data = {
            name: studentAge
        }
        await axios.post(`${API}/student-age`, data, {
            headers: {
                "Content-Type": "application/json",
                "token": localStorage.getItem("token")
            }
        })
            .then((res) => {
                // console.log(res)
                alert(res.data.message)
                setupdateTable(!updateTable)
                clearfields()
            })
            .catch((err) => {
                // console.log(err)
                alert(err.response.data.message)
            })
    }


    // ----------create student age end ----------

    //------- get all student age start -----------
    const [getAllStudetnAge, setgetAllStudetnAge] = useState([])
    useEffect(() => {
        axios.get(`${API}/student-age`)
            .then((res) => {
                // console.log(res.data.data)
                setgetAllStudetnAge(res.data.data)

            }).catch((err) => {
                console.log(err)
            })
    }, [updateTable])
    //------- get all student age end -----------

    // -------edit student age start --------------
    const [editStudentAgeModal, seteditStudentAgeModal] = useState(false)

    const [editSTUDENTaGE, seteditSTUDENTaGE] = useState("")

    const handleEditSTUAGEPop = (item) => {
        seteditStudentAgeModal(true)
        setselectedRowData(item)
    }

    const handleeditStudentAge = (id) => {
        const data = {
            name: editSTUDENTaGE
        }
        axios.put(`${API}/student-age/${id}`, data, {
            headers: {
                "Content-Type": "application/json",
                "token": localStorage.getItem("token")
            }
        })
            .then((res) => {
                // console.log(res)
                alert(res.data.message)
                setupdateTable(!updateTable)
                seteditStudentAgeModal(false)
            })
            .catch((err) => {
                console.log(err)
                alert(err.response.data.message)
            })
    }

    // -------edit student age end --------------


    // ----------delete student age start -------------
    const [deleteStuAge, setdeleteStuAge] = useState(false)
    const [deleteStuAgeid, setsetdeleteStuAgeid] = useState('')

    const HandlePOPStuAge = (id) => {
        setdeleteStuAge(true)
        setsetdeleteStuAgeid(id)
    }

    const handleDeleteStuAge = (id) => {
        axios.delete(`${API}/student-age/${id}`,{
            headers:{
                "Content-Type": "application/json",
                "token": localStorage.getItem("token")
            }
        })
            .then((res) => {
                console.log(res)
                // alert(res.data.message)
                setdeleteStuAge(false)
                setupdateTable(!updateTable)

            })
            .catch((err) => {
                console.log(err)
            })

    }

    // ----------delete student age end ---------------


    // ====================operation on student age end =============================



    //======================= operation on set default start =============================

    // -----------default session start -----------------
    const [DefaultModal, setDefaultModal] = useState(false)
    const [fetcheddefaultSession, setfetcheddefaultSession] = useState("")


    useEffect(() => {
        axios.get(`${API}/default-session/66c44d078b84a11874513d8c`,{
            headers: {
                "Content-Type": "application/json",
                "token": localStorage.getItem("token")
            }
        })
            .then((res) => {
                // console.log(res.data.data.default_session)
                setfetcheddefaultSession(res.data.data.default_session)
            })
            .catch((err) => {
                console.log(err)
            })
    }, [])


    const handleUpdateDefaultSession = async (id) => {
        try {
            const data = {
                default_session: fetcheddefaultSession
            }

            await axios.put(`${API}/default-session/${id}`, data,{
                headers: {
                    "Content-Type": "application/json",
                    "token": localStorage.getItem("token")
                }
            })
                .then((res) => {
                    // console.log(res)
                    alert(res.data.message)
                })
                .catch((err) => {
                    console.log(err);
                    alert(err.response.data.message)

                })
        } catch (error) {

        }
    }

    // ---------------default session end -------------------



    // ---------------default quarter start -------------------
    const [fetcheddefaultQuarter, setfetcheddefaultQuarter] = useState("")



    useEffect(() => {
        axios.get(`${API}/default-quarter/66c454ba55b891fa6685b020`)
            .then((res) => {
                // console.log(res.data.data.default_session)
                setfetcheddefaultQuarter(res.data.data.default_Quarter)
            })
            .catch((err) => {
                console.log(err)
            })
    }, [])


    const handleUpdateDefaultQuarter = async (id) => {
        try {
            const data = {
                default_Quarter: fetcheddefaultQuarter
            }

            await axios.put(`${API}/default-quarter/${id}`, data,{
                headers: {
                    "Content-Type": "application/json",
                    "token": localStorage.getItem("token")
                }
            })
                .then((res) => {
                    // console.log(res)
                    alert(res.data.message)
                })
                .catch((err) => {
                    console.log(err);
                    alert(err.response.data.message)

                })
        } catch (error) {

        }
    }


    // ---------------default quarter end -------------------



    //======================= operation on set default end =============================

    const clearfields = () => {
        setclass_name("")
        setschool_location("")
        setsessionName("")
        setquarterName("")
        setClassNameforSection('')
        setSectionName([])
        setstudentAge("")
    }



    return (
        <div>
            {
                loggedinRole && loggedinRole==="Admin" ||loggedinRole ==="Super Admin" ? (
                    <div>
                    <Header />
                    <div className='flex justify-center mt-[150px]'>
                        <div className='max-w-[1500px] w-full  ' >
                            <div className='flex flex-wrap justify-start gap-[30px]  '>
                                <div onClick={() => setshowModalClass(true)} className='px-[10px] py-[15px] shadow-md shadow-black w-[350px] mt-[20px] cursor-pointer '>
                                    <div className='flex justify-center'>
                                        <SiGoogleclassroom size={40} />
                                    </div>
                                    <div>
                                        <h2 className='text-[25px] font-medium text-[#3648FE] text-center'>Create Class</h2>
                                    </div>
                                </div>
    
                                <div onClick={() => setshowModalSection(true)} className='px-[10px] py-[15px] shadow-md shadow-black  w-[350px] mt-[20px] cursor-pointer'>
                                    <div className='flex justify-center'>
                                        <BsSignIntersectionY size={40} />
                                    </div>
                                    <div>
                                        <h2 className='text-[25px] font-medium text-[#3648FE] text-center'>Create Section</h2>
                                    </div>
                                </div>
    
                                <div onClick={() => setshowModalLocation(true)} className='px-[10px] py-[15px] shadow-md shadow-black  w-[350px] mt-[20px] cursor-pointer'>
                                    <div className='flex justify-center'>
                                        <MdOutlineAddLocationAlt size={40} />
                                    </div>
                                    <div>
                                        <h2 className='text-[25px] font-medium text-[#3648FE] text-center'>School Location</h2>
                                    </div>
                                </div>
    
                                <div onClick={() => setcreateSession(true)} className='px-[10px] py-[15px] shadow-md shadow-black  w-[350px] mt-[20px] cursor-pointer'>
                                    <div className='flex justify-center'>
                                        <MdCalendarMonth size={40} />
                                    </div>
                                    <div>
                                        <h2 className='text-[25px] font-medium text-[#3648FE] text-center'>Create Session</h2>
                                    </div>
                                </div>
    
    
                                <div onClick={() => setcreateQuarter(true)} className='px-[10px] py-[15px] shadow-md shadow-black  w-[350px] mt-[20px] cursor-pointer'>
                                    <div className='flex justify-center'>
                                        <BiSolidCircleThreeQuarter size={40} />
                                    </div>
                                    <div>
                                        <h2 className='text-[25px] font-medium text-[#3648FE] text-center'>Create Quarter</h2>
                                    </div>
                                </div>
    
    
                                <div onClick={() => setstudentAgeModal(true)} className='px-[10px] py-[15px] shadow-md shadow-black  w-[350px] mt-[20px] cursor-pointer'>
                                    <div className='flex justify-center'>
                                        <GrVirtualStorage size={40} />
                                    </div>
                                    <div>
                                        <h2 className='text-[25px] font-medium text-[#3648FE] text-center'>Student Age</h2>
                                    </div>
                                </div>
    
    
                                <div onClick={() => setDefaultModal(true)} className='px-[10px] py-[15px] shadow-md shadow-black  w-[350px] mt-[20px] cursor-pointer'>
                                    <div className='flex justify-center'>
                                        <MdOutlineSettingsInputComponent size={40} />
                                    </div>
                                    <div>
                                        <h2 className='text-[25px] font-medium text-[#3648FE] text-center'>Set Default</h2>
                                    </div>
                                </div>
    
    
    
                                <div onClick={() => setShowRubric(true)} className='px-[10px] py-[15px] shadow-md shadow-black  w-[350px] mt-[20px] cursor-pointer'>
                                    <div className='flex justify-center'>
                                        <FaChartArea size={40} />
                                    </div>
                                    <div>
                                        <h2 className='text-[25px] font-medium text-[#3648FE] text-center'>Show Rubric</h2>
                                    </div>
                                </div>
                            </div>
    
                            {/* =============================class all modals start======================  */}
                            {
                                showModalClass && showModalClass ? (
                                    <div>
                                        <div className='fixed inset-0 flex justify-center items-center bg-black/70'>
                                            <div className=' w-[500px] bg-white'>
                                                <div className='bg-[#8321A8] text-white flex justify-between items-center px-[10px]'>
                                                    <div> <h1 className='text-[30px] '>Create Class</h1></div>
                                                    <div ><MdClose onClick={() => setshowModalClass(false)} size={35} /></div>
                                                </div>
                                                <div>
                                                    <div className='flex'>
                                                        <div className='px-[20px] mt-[10px] w-full'>
                                                            <div className='text-[18px]'>
                                                                <label htmlFor="">Class Name:</label>
                                                            </div>
                                                            <div>
                                                                <input value={class_name} onChange={(e) => setclass_name(e.target.value)} className='bg-black px-[10px] py-[5px] rounded-md text-white w-full outline-none' type="text" placeholder='Class Name' />
                                                            </div>
    
                                                        </div>
                                                        <div></div>
                                                    </div>
    
                                                    <div className='flex justify-start my-[10px] px-[20px]'>
                                                        <button onClick={() => handleCreateClass()} className='bg-[#1B1B1B] text-white px-[20px] py-[5px] font-semibold text-[15px] rounded-md'>Add</button>
                                                    </div>
                                                </div>
    
                                                <div className='w-full h-[300px] overflow-hidden overflow-y-scroll'>
                                                    <table className='w-full'>
                                                        <thead>
                                                            <tr className=' border-[1px] solid'>
                                                                <th>#</th>
                                                                <th>Class Name</th>
                                                                <th>Edit</th>
                                                                <th className='text-start'>Delete</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody className='w-full'>
                                                            {
                                                                allClassDATA && allClassDATA.map((data, index) => {
                                                                    return (
                                                                        <tr className='text-center border-[1px] solid ' key={index}>
                                                                            <td>{index + 1}</td>
                                                                            <td>{data.name}</td>
                                                                            <td className='flex justify-center'><FaEdit onClick={() => handleEditClass(data)} /></td>
                                                                            <td ><MdDelete onClick={(() => { handledeletePopUp(data._id) })} /></td>
                                                                        </tr>
                                                                    )
    
                                                                })
                                                            }
                                                            {/* <tr className='text-center border-[1px] solid'>
                                                                <td>2</td>
                                                                <td>Jacob</td>
                                                                <td className='flex justify-center'><FaEdit /></td>
                                                                <td ><MdDelete /></td>
                                                            </tr> */}
    
                                                        </tbody>
                                                    </table>
                                                </div>
    
                                            </div>
    
                                        </div>
                                    </div>
                                ) : null
                            }
    
                            {
                                EditClassModal && EditClassModal ? (
                                    <div className='inset-0 flex justify-center items-center fixed z-[50] bg-[#1c1d1f]/30' >
                                        <div className='w-[350px]'>
                                            <div className='bg-[#6C7AE0] py-[10px] px-[10px] flex justify-between'><h5 className='text-white text-[25px]'>Edit Class</h5> <button onClick={() => setEditClassModal(false)}><IoMdClose size={30} color='white' /></button></div>
                                            {/* input field block start */}
                                            <div className='p-[10px] bg-white'>
    
                                                <div className='p-[5px] flex justify-between'>
                                                    <div className='w-full'>
                                                        <label htmlFor="edit_school_location">Class:</label>
                                                        <input id='edit_school_location' value={selectedRowData?.name}
                                                            onChange={(e) => {
                                                                const newClassname = e.target.value
                                                                setselectedRowData((prev) => ({ ...prev, name: newClassname }))
                                                                seteditClassName(newClassname)
                                                            }
                                                            }
                                                            className='w-full p-[8px] rounded-md outline-none bg-[#121212] text-white' type="text" placeholder='Enter School Location' />
                                                    </div>
    
                                                </div>
                                                <div className=' p-[5px] flex justify-start my-[10px]'>
                                                    <button onClick={() => editClass(selectedRowData._id)} className='hover:bg-[#6C7AE0] bg-[#121212] px-[15px] py-[5px] text-white rounded-md' >Update</button>
                                                </div>
    
                                            </div>
                                            {/* input field block end */}
                                        </div>
                                    </div>
                                ) : null
                            }
    
                            {
                                deletePopUp && deletePopUp ? (
                                    <div className='inset-0 flex justify-center items-center fixed z-[50] bg-[#1c1d1f]/30' >
                                        <div className='w-[300px] bg-black rounded-md py-[20px]'>
                                            <div>
                                                <h4 className='text-[12px] text-white font-semibold text-center'>This Wil permanently delete this data, would you like to delete?</h4>
                                            </div>
    
    
    
                                            <div className='flex gap-6 justify-center my-[10px]'>
                                                {/* <button onClick={editCalculateUtilization} className='bg-[#1a5800] px-[15px] py-[5px] text-white rounded-md' >Calculate Total Utilization</button> */}
                                                <button onClick={() => handleDelete(DeleteId)} className='bg-[#ec4848] px-[15px] py-[5px] text-white rounded-md' >Delete</button>
                                                <button onClick={() => setdeletePopUp(false)} className='bg-[#1a5800] px-[15px] py-[5px] text-white rounded-md' >Cancel</button>
                                            </div>
                                        </div>
                                        {/* input field block end */}
                                    </div>
                                ) : null
                            }
                            {/* =============================class all modals end======================  */}
    
    
    
    
    
                            {/*========================== section all modal start============================  */}
    
    
                            {
                                showModalSection && showModalSection ? (
                                    <div>
                                        <div className='fixed inset-0 flex justify-center items-center bg-black/70'>
                                            <div className=' w-[500px] bg-white'>
                                                <div className='bg-[#8321A8] text-white flex justify-between items-center px-[10px]'>
                                                    <div> <h1 className='text-[30px] '>Create Section</h1></div>
                                                    <div ><MdClose onClick={() => setshowModalSection(false)} size={35} /></div>
                                                </div>
                                                <div>
                                                    <div className='flex'>
                                                        <div className='px-[20px] mt-[10px] w-[50%]'>
                                                            <div className='text-[18px]'>
                                                                <label htmlFor="">Select Class:</label>
                                                            </div>
                                                            <div>
                                                                <select
                                                                    onChange={(e) => setClassNameforSection(e.target.value)}
                                                                    value={classNameforSection}
                                                                    className='bg-black px-[10px] py-[5px] rounded-md text-white w-full outline-none'>
                                                                    <option value="">Select Class Name</option>
                                                                    {
                                                                        allClassDATA && allClassDATA.map((item, index) => {
                                                                            return (
                                                                                <option key={index} value={item.name}>{item.name}</option>
                                                                            )
                                                                        })
                                                                    }
                                                                </select>
                                                            </div>
    
                                                        </div>
                                                        <div className='px-[20px] mt-[10px] w-[50%]'>
                                                            <div className='text-[18px]'>
                                                                <label htmlFor="">Section Name:</label>
                                                            </div>
                                                            <div className=''>
                                                                {/* <input className='bg-black px-[10px] py-[5px] rounded-md text-white w-full outline-none' type="text" placeholder='Section Name' /> */}
                                                                <Select
                                                                    labelId="demo-multiple-checkbox-label"
                                                                    id="demo-multiple-checkbox"
                                                                    style={{ color: "white" }}
                                                                    className='rounded-md bg-black  w-full outline-none MuiSelect-select  '
                                                                    multiple
                                                                    value={sectionName}
                                                                    onChange={handleChange}
                                                                    placeholder='Select Section'
                                                                    // onChange={handleSearchSection}
                                                                    // input={<OutlinedInput  label="Select Section" />}
                                                                    renderValue={(selected) => selected.join(',')}
                                                                    MenuProps={MenuProps}
                                                                >
                                                                    {names && names.map((name, index) => (
    
                                                                        <MenuItem selected className="MenuItem" key={name} value={name}>
                                                                            <Checkbox checked={sectionName.indexOf(name) > -1} />
                                                                            <ListItemText primary={name} />
                                                                        </MenuItem>
    
                                                                    ))}
                                                                </Select>
                                                            </div>
    
                                                        </div>
                                                        <div></div>
                                                    </div>
    
                                                    <div className='flex justify-center my-[10px]'>
                                                        <button onClick={() => handleSubmitSection()} className='bg-[#1B1B1B] text-white px-[20px] py-[5px] font-semibold text-[15px] rounded-md'>Add</button>
                                                    </div>
                                                </div>
    
                                                {/* table start  */}
                                                <div className='w-full h-[250px] overflow-hidden  overflow-y-scroll'>
                                                    <table className='w-full'>
                                                        <thead>
                                                            <tr className=' border-[1px] solid'>
                                                                <th>#</th>
                                                                <th>Class Name</th>
                                                                <th>Section Name</th>
                                                                <th>Edit</th>
                                                                <th className='text-start'>Delete</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody className='w-full'>
    
                                                            {
                                                                get_section && get_section.map((item, index) => {
                                                                    return (
                                                                        <tr key={index} className='text-center border-[1px] solid'>
                                                                            <td>{index + 1}</td>
                                                                            <td>{item.class_name}</td>
                                                                            <td>{item.sections.join(",")}</td>
                                                                            <td onClick={() => handleEditSection(item._id)} className='flex justify-center'><FaEdit /></td>
                                                                            <td ><MdDelete onClick={() => handledeleteSectionPopUp(item._id)} /></td>
                                                                        </tr>
                                                                    )
                                                                })
                                                            }
    
                                                            {/* <tr className='text-center border-[1px] solid'>
                                                                <td>2</td>
                                                                <td>Jacob</td>
                                                                <td>Jacob</td>
                                                                <td className='flex justify-center'><FaEdit /></td>
                                                                <td ><MdDelete /></td>
                                                            </tr> */}
    
                                                        </tbody>
                                                    </table>
                                                </div>
                                                {/* table end  */}
    
    
                                            </div>
    
                                        </div>
                                    </div>
                                ) : null
                            }
    
    
    
                            {
                                editshowModalSection && editshowModalSection ? (
                                    <div>
                                        <div className='fixed inset-0 flex justify-center items-center bg-black/70'>
                                            <div className=' w-[450px] bg-white'>
                                                <div className='bg-[#6C7AE0] text-white flex justify-between items-center px-[10px]'>
                                                    <div> <h1 className='text-[30px] '>Update Section</h1></div>
                                                    <div ><MdClose onClick={() => seteditshowModalSection(false)} size={35} /></div>
                                                </div>
                                                <div>
                                                    <div className='flex'>
                                                        <div className='px-[20px] mt-[10px] w-[50%]'>
                                                            <div className='text-[18px]'>
                                                                <label htmlFor="">Select Class:</label>
                                                            </div>
                                                            <div>
                                                                <select
                                                                    onChange={(e) => seteditClassNameforSection(e.target.value)}
                                                                    value={editclassNameforSection}
                                                                    className='bg-black px-[10px] py-[5px] rounded-md text-white w-full outline-none'>
                                                                    <option value="">Select Class Name</option>
                                                                    {
                                                                        allClassDATA && allClassDATA.map((item, index) => {
                                                                            return (
                                                                                <option key={index} value={item.name}>{item.name}</option>
                                                                            )
                                                                        })
                                                                    }
                                                                </select>
                                                            </div>
    
                                                        </div>
                                                        <div className='px-[20px] mt-[10px] w-[50%]'>
                                                            <div className='text-[18px]'>
                                                                <label htmlFor="">Section Name:</label>
                                                            </div>
                                                            <div className=''>
                                                                {/* <input className='bg-black px-[10px] py-[5px] rounded-md text-white w-full outline-none' type="text" placeholder='Section Name' /> */}
                                                                <Select
                                                                    labelId="demo-multiple-checkbox-label"
                                                                    id="demo-multiple-checkbox"
                                                                    style={{ color: "white" }}
                                                                    className='rounded-md bg-black  w-full outline-none MuiSelect-select  '
                                                                    multiple
                                                                    value={editsectionName}
                                                                    onChange={handleEditChange}
                                                                    placeholder='Select Section'
                                                                    // onChange={handleSearchSection}
                                                                    // input={<OutlinedInput  label="Select Section" />}
                                                                    renderValue={(selected) => selected.join(',')}
                                                                    MenuProps={MenuProps}
                                                                >
                                                                    {names && names.map((name, index) => (
    
                                                                        <MenuItem selected className="MenuItem" key={index} value={name}>
                                                                            <Checkbox checked={editsectionName.indexOf(name) > -1} />
                                                                            <ListItemText primary={name} />
                                                                        </MenuItem>
    
                                                                    ))}
                                                                </Select>
                                                            </div>
    
                                                        </div>
                                                        <div></div>
                                                    </div>
    
                                                    <div className='flex justify-center my-[10px]'>
                                                        <button onClick={() => handleEditSubmitSection(editsectionID)} className='bg-[#1B1B1B] text-white px-[20px] py-[5px] font-semibold text-[15px] rounded-md'>Update</button>
                                                    </div>
                                                </div>
    
    
    
    
                                            </div>
    
                                        </div>
                                    </div>
                                ) : null
                            }
    
    
                            {
                                deleteSectionPopUp && deleteSectionPopUp ? (
                                    <div className='inset-0 flex justify-center items-center fixed z-[50] bg-[#1c1d1f]/30' >
                                        <div className='w-[300px] bg-black rounded-md py-[20px]'>
                                            <div>
                                                <h4 className='text-[12px] text-white font-semibold text-center'>This Wil permanently delete this data, would you like to delete?</h4>
                                            </div>
    
    
    
                                            <div className='flex gap-6 justify-center my-[10px]'>
                                                {/* <button onClick={editCalculateUtilization} className='bg-[#1a5800] px-[15px] py-[5px] text-white rounded-md' >Calculate Total Utilization</button> */}
                                                <button onClick={() => handleDeleteSection(DeleteSectionId)} className='bg-[#ec4848] px-[15px] py-[5px] text-white rounded-md' >Delete</button>
                                                <button onClick={() => setdeleteSectionPopUp(false)} className='bg-[#1a5800] px-[15px] py-[5px] text-white rounded-md' >Cancel</button>
                                            </div>
                                        </div>
                                        {/* input field block end */}
                                    </div>
                                ) : null
                            }
    
                            {/*========================== section all modal end============================  */}
    
    
    
    
    
                            {/* ==========================school location start===============================  */}
                            {
                                showModalLocation && showModalLocation ? (
                                    <div>
                                        <div className='fixed inset-0 flex justify-center items-center bg-black/70'>
                                            <div className=' w-[500px] bg-white'>
                                                <div className='bg-[#8321A8] text-white flex justify-between items-center px-[10px]'>
                                                    <div> <h1 className='text-[30px] '>Create Location</h1></div>
                                                    <div ><MdClose onClick={() => setshowModalLocation(false)} size={35} /></div>
                                                </div>
                                                <div>
                                                    <div className='flex'>
                                                        <div className='px-[20px] mt-[10px] w-full'>
                                                            <div className='text-[18px]'>
                                                                <label htmlFor="">Location Name:</label>
                                                            </div>
                                                            <div>
                                                                <input value={school_location} onChange={(e) => setschool_location(e.target.value)} className='bg-black px-[10px] py-[5px] rounded-md text-white w-full outline-none' type="text" placeholder='Location Name' />
                                                            </div>
    
                                                        </div>
                                                        <div></div>
                                                    </div>
    
                                                    <div className='flex justify-center my-[10px]'>
                                                        <button onClick={handleCreateSchoolLOCATION} className='bg-[#1B1B1B] text-white px-[20px] py-[5px] font-semibold text-[15px] rounded-md'>Add</button>
                                                    </div>
                                                </div>
    
                                                {/* table start  */}
                                                <div className='w-full'>
                                                    <table className='w-full'>
                                                        <thead>
                                                            <tr className=' border-[1px] solid'>
                                                                <th>#</th>
                                                                <th>Class Name</th>
                                                                <th>Edit</th>
                                                                <th className='text-start'>Delete</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody className='w-full'>
                                                            {
                                                                allLocationData && allLocationData.map((data, index) => {
                                                                    return (
                                                                        <tr className='text-center border-[1px] solid ' key={index}>
                                                                            <td>{index + 1}</td>
                                                                            <td>{data.name}</td>
                                                                            <td className='flex justify-center'><FaEdit onClick={() => handleEditSchoolLocationpop(data)} /></td>
                                                                            <td ><MdDelete onClick={(() => { handledeletePopUpLocation(data._id) })} /></td>
                                                                        </tr>
                                                                    )
    
                                                                })
                                                            }
    
                                                            {/* <tr className='text-center border-[1px] solid'>
                                                                <td>2</td>
                                                                <td>Jacob</td>
                                                                <td className='flex justify-center'><FaEdit /></td>
                                                                <td ><MdDelete /></td>
                                                            </tr> */}
    
                                                        </tbody>
                                                    </table>
                                                </div>
                                                {/* table end  */}
    
                                            </div>
    
                                        </div>
                                    </div>
                                ) : null
                            }
    
                            {
                                EditSchoolLocationModal && EditSchoolLocationModal ? (
                                    <div className='inset-0 flex justify-center items-center fixed z-[50] bg-[#1c1d1f]/30' >
                                        <div className='w-[350px]'>
                                            <div className='bg-[#6C7AE0] py-[10px] px-[10px] flex justify-between'><h5 className='text-white text-[25px]'>Edit Section</h5>
                                                <button onClick={() => setEditSchoolLocationModal(false)}><IoMdClose size={30} color='white' /></button></div>
                                            {/* input field block start */}
                                            <div className='p-[10px] bg-white'>
    
                                                <div className='p-[5px] flex justify-between'>
                                                    <div className='w-full'>
                                                        <label htmlFor="edit_school_location">School Location:</label>
                                                        <input id='edit_school_location' value={selectedRowData?.name}
                                                            onChange={(e) => {
                                                                const newLocationName = e.target.value
                                                                setselectedRowData((prev) => ({ ...prev, name: newLocationName }))
                                                                seteditschoolLocation(newLocationName)
                                                            }
                                                            }
                                                            className='w-full p-[8px] rounded-md outline-none bg-[#121212] text-white' type="text" placeholder='Enter School Location' />
                                                    </div>
    
                                                </div>
                                                <div className=' p-[5px] flex justify-start my-[10px]'>
                                                    <button onClick={() => handleeditSchoolLocation(selectedRowData._id)} className='hover:bg-[#6C7AE0] bg-[#121212] px-[15px] py-[5px] text-white rounded-md' >Update</button>
                                                </div>
    
                                            </div>
                                            {/* input field block end */}
                                        </div>
                                    </div>
                                ) : null
                            }
    
                            {
                                deletePopUpLocationModal && deletePopUpLocationModal ? (
                                    <div className='inset-0 flex justify-center items-center fixed z-[50] bg-[#1c1d1f]/30' >
                                        <div className='w-[300px] bg-black rounded-md py-[20px]'>
                                            <div>
                                                <h4 className='text-[12px] text-white font-semibold text-center'>This Wil permanently delete this data, would you like to delete?</h4>
                                            </div>
    
    
    
                                            <div className='flex gap-6 justify-center my-[10px]'>
                                                {/* <button onClick={editCalculateUtilization} className='bg-[#1a5800] px-[15px] py-[5px] text-white rounded-md' >Calculate Total Utilization</button> */}
                                                <button onClick={() => handleDeleteLocation(DeleteIdLocation)} className='bg-[#ec4848] px-[15px] py-[5px] text-white rounded-md' >Delete</button>
                                                <button onClick={() => setdeletePopUpLocationModal(false)} className='bg-[#1a5800] px-[15px] py-[5px] text-white rounded-md' >Cancel</button>
                                            </div>
                                        </div>
                                        {/* input field block end */}
                                    </div>
                                ) : null
                            }
                            {/* ============================school location end================================== */}
    
    
    
    
                            {/* ============================create session start====================================  */}
    
                            {
                                createSession && createSession ? (
                                    <div>
                                        <div className='fixed inset-0 flex justify-center items-center bg-black/70'>
                                            <div className=' w-[500px] bg-white'>
                                                <div className='bg-[#8321A8] text-white flex justify-between items-center px-[10px]'>
                                                    <div> <h1 className='text-[30px] '>Create Session</h1></div>
                                                    <div ><MdClose onClick={() => setcreateSession(false)} size={35} /></div>
                                                </div>
                                                <div>
                                                    <div className='flex'>
                                                        <div className='px-[20px] mt-[10px] w-full'>
                                                            <div className='text-[18px]'>
                                                                <label htmlFor="">Session Name:</label>
                                                            </div>
                                                            <div>
                                                                <input value={sessionName} onChange={(e) => setsessionName(e.target.value)} className='bg-black px-[10px] py-[5px] rounded-md text-white w-full outline-none' type="text" placeholder='Session Name' />
                                                            </div>
    
                                                        </div>
                                                        <div></div>
                                                    </div>
    
                                                    <div className='flex justify-center my-[10px]'>
                                                        <button onClick={() => handleCreateSession()} className='bg-[#1B1B1B] text-white px-[20px] py-[5px] font-semibold text-[15px] rounded-md'>Add</button>
                                                    </div>
                                                </div>
    
                                                {/* table start  */}
                                                <div className='w-full'>
                                                    <table className='w-full'>
                                                        <thead>
                                                            <tr className=' border-[1px] solid'>
                                                                <th>#</th>
                                                                <th>Class Name</th>
                                                                <th>Edit</th>
                                                                <th className='text-start'>Delete</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody className='w-full'>
                                                            {
                                                                allsessiondata && allsessiondata.map((data, index) => {
                                                                    return (
                                                                        <tr className='text-center border-[1px] solid ' key={index}>
                                                                            <td>{index + 1}</td>
                                                                            <td>{data.name}</td>
                                                                            <td className='flex justify-center'><FaEdit onClick={() => handleEditsessionPop(data)} /></td>
                                                                            <td ><MdDelete onClick={(() => { HandlePOPsession(data._id) })} /></td>
                                                                        </tr>
                                                                    )
    
                                                                })
                                                            }
                                                            {/* <tr className='text-center border-[1px] solid'>
                                                                <td>2</td>
                                                                <td>Jacob</td>
                                                                <td className='flex justify-center'><FaEdit /></td>
                                                                <td ><MdDelete /></td>
                                                            </tr> */}
    
                                                        </tbody>
                                                    </table>
                                                </div>
                                                {/* table end  */}
    
                                            </div>
    
                                        </div>
                                    </div>
                                ) : null
                            }
    
                            {
                                editsessionModal && editsessionModal ? (
                                    <div className='inset-0 flex justify-center items-center fixed z-[50] bg-[#1c1d1f]/30' >
                                        <div className='w-[350px]'>
                                            <div className='bg-[#6C7AE0] py-[10px] px-[10px] flex justify-between'>
                                                <h5 className='text-white text-[25px]'>Edit Session</h5>
                                                <button onClick={() => seteditsessionModal(false)}><IoMdClose size={30} color='white' /></button></div>
                                            {/* input field block start */}
                                            <div className='p-[10px] bg-white'>
    
                                                <div className='p-[5px] flex justify-between'>
                                                    <div className='w-full'>
                                                        <label htmlFor="edit_school_location">Session:</label>
                                                        <input id='edit_school_location' value={selectedRowData?.name}
                                                            onChange={(e) => {
                                                                const newLocationName = e.target.value
                                                                setselectedRowData((prev) => ({ ...prev, name: newLocationName }))
                                                                seteditSessionName(newLocationName)
                                                            }}
                                                            className='w-full p-[8px] rounded-md outline-none bg-[#121212] text-white' type="text" placeholder='Enter School Location' />
                                                    </div>
    
                                                </div>
                                                <div className=' p-[5px] flex justify-start my-[10px]'>
                                                    <button onClick={() => handleeditsession(selectedRowData._id)} className='hover:bg-[#6C7AE0] bg-[#121212] px-[15px] py-[5px] text-white rounded-md' >Update</button>
                                                </div>
    
                                            </div>
                                            {/* input field block end */}
                                        </div>
                                    </div>
                                ) : null
                            }
    
                            {
                                deletePopSession && deletePopSession ? (
                                    <div className='inset-0 flex justify-center items-center fixed z-[50] bg-[#1c1d1f]/30' >
                                        <div className='w-[300px] bg-black rounded-md py-[20px]'>
                                            <div>
                                                <h4 className='text-[12px] text-white font-semibold text-center'>This Wil permanently delete this data, would you like to delete?</h4>
                                            </div>
    
    
    
                                            <div className='flex gap-6 justify-center my-[10px]'>
                                                {/* <button onClick={editCalculateUtilization} className='bg-[#1a5800] px-[15px] py-[5px] text-white rounded-md' >Calculate Total Utilization</button> */}
                                                <button onClick={() => handleDeletesession(deletePopSESSIONid)} className='bg-[#ec4848] px-[15px] py-[5px] text-white rounded-md' >Delete</button>
                                                <button onClick={() => setdeletePopSession(false)} className='bg-[#1a5800] px-[15px] py-[5px] text-white rounded-md' >Cancel</button>
                                            </div>
                                        </div>
                                        {/* input field block end */}
                                    </div>
                                ) : null
                            }
    
                            {/* ============================create session end====================================  */}
    
    
    
    
    
    
                            {/* ===================create quarter start========================  */}
                            {
                                createQuarter && createQuarter ? (
                                    <div>
                                        <div className='fixed inset-0 flex justify-center items-center bg-black/70'>
                                            <div className=' w-[500px] bg-white'>
                                                <div className='bg-[#8321A8] text-white flex justify-between items-center px-[10px]'>
                                                    <div> <h1 className='text-[30px] '>Create Quarter</h1></div>
                                                    <div ><MdClose onClick={() => setcreateQuarter(false)} size={35} /></div>
                                                </div>
                                                <div>
                                                    <div className='flex'>
                                                        <div className='px-[20px] mt-[10px] w-full'>
                                                            <div className='text-[18px]'>
                                                                <label htmlFor="">Quarter Name:</label>
                                                            </div>
                                                            <div>
                                                                <input value={quarterName} onChange={(e) => setquarterName(e.target.value)} className='bg-black px-[10px] py-[5px] rounded-md text-white w-full outline-none' type="number" placeholder='Quarter Name' />
                                                            </div>
    
                                                        </div>
                                                        <div></div>
                                                    </div>
    
                                                    <div className='flex justify-center my-[10px]'>
                                                        <button onClick={() => handleCreateQuarter()} className='bg-[#1B1B1B] text-white px-[20px] py-[5px] font-semibold text-[15px] rounded-md'>Add</button>
                                                    </div>
                                                </div>
    
                                                {/* table start  */}
                                                <div className='w-full'>
                                                    <table className='w-full'>
                                                        <thead>
                                                            <tr className=' border-[1px] solid'>
                                                                <th>#</th>
                                                                <th>Quarter Name</th>
                                                                <th>Edit</th>
                                                                <th className='text-start'>Delete</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody className='w-full'>
                                                            {
                                                                quarterData && quarterData.map((data, index) => {
                                                                    return (
                                                                        <tr className='text-center border-[1px] solid ' key={index}>
                                                                            <td>{index + 1}</td>
                                                                            <td>{data.name}</td>
                                                                            <td className='flex justify-center'><FaEdit onClick={() => handleEditQuarterPop(data)} /></td>
                                                                            <td ><MdDelete onClick={(() => { HandlePOPQuarter(data._id) })} /></td>
                                                                        </tr>
                                                                    )
    
                                                                })
                                                            }
                                                            {/* <tr className='text-center border-[1px] solid'>
                                                                <td>2</td>
                                                                <td>Jacob</td>
                                                                <td className='flex justify-center'><FaEdit /></td>
                                                                <td ><MdDelete /></td>
                                                            </tr> */}
    
                                                        </tbody>
                                                    </table>
                                                </div>
                                                {/* table end  */}
    
                                            </div>
    
                                        </div>
                                    </div>
                                ) : null
                            }
    
    
                            {
                                editquarterModal && editquarterModal ? (
                                    <div className='inset-0 flex justify-center items-center fixed z-[50] bg-[#1c1d1f]/30' >
                                        <div className='w-[350px]'>
                                            <div className='bg-[#6C7AE0] py-[10px] px-[10px] flex justify-between'>
                                                <h5 className='text-white text-[25px]'>Edit Quarter</h5>
                                                <button onClick={() => seteditquarterModal(false)}><IoMdClose size={30} color='white' /></button></div>
                                            {/* input field block start */}
                                            <div className='p-[10px] bg-white'>
    
                                                <div className='p-[5px] flex justify-between'>
                                                    <div className='w-full'>
                                                        <label htmlFor="edit_school_location">Quarter:</label>
                                                        <input id='edit_school_location' value={selectedRowData?.name}
                                                            onChange={(e) => {
                                                                const newLocationName = e.target.value
                                                                setselectedRowData((prev) => ({ ...prev, name: newLocationName }))
                                                                seteditQuarterName(newLocationName)
                                                            }
                                                            }
                                                            className='w-full p-[8px] rounded-md outline-none bg-[#121212] text-white' type="text" placeholder='Enter School Location' />
                                                    </div>
    
                                                </div>
                                                <div className=' p-[5px] flex justify-start my-[10px]'>
                                                    <button onClick={() => handleeditquarter(selectedRowData._id)} className='hover:bg-[#6C7AE0] bg-[#121212] px-[15px] py-[5px] text-white rounded-md' >Update</button>
                                                </div>
    
                                            </div>
                                            {/* input field block end */}
                                        </div>
                                    </div>
                                ) : null
                            }
    
    
                            {
                                deletePopQuarter && deletePopQuarter ? (
                                    <div className='inset-0 flex justify-center items-center fixed z-[50] bg-[#1c1d1f]/30' >
                                        <div className='w-[300px] bg-black rounded-md py-[20px]'>
                                            <div>
                                                <h4 className='text-[12px] text-white font-semibold text-center'>This Wil permanently delete this data, would you like to delete?</h4>
                                            </div>
    
    
    
                                            <div className='flex gap-6 justify-center my-[10px]'>
                                                {/* <button onClick={editCalculateUtilization} className='bg-[#1a5800] px-[15px] py-[5px] text-white rounded-md' >Calculate Total Utilization</button> */}
                                                <button onClick={() => handleDeletequarter(deletePopQuarterid)} className='bg-[#ec4848] px-[15px] py-[5px] text-white rounded-md' >Delete</button>
                                                <button onClick={() => setdeletePopQuarter(false)} className='bg-[#1a5800] px-[15px] py-[5px] text-white rounded-md' >Cancel</button>
                                            </div>
                                        </div>
                                        {/* input field block end */}
                                    </div>
                                ) : null
                            }
                            {/* ===================create quarter end========================  */}
    
    
    
                            {/* ===================student age start===========================  */}
                            {
                                studentAgeModal && studentAgeModal ? (
                                    <div>
                                        <div className='fixed inset-0 flex justify-center items-center bg-black/70'>
                                            <div className=' w-[500px] bg-white'>
                                                <div className='bg-[#8321A8] text-white flex justify-between items-center px-[10px]'>
                                                    <div> <h1 className='text-[30px] '>Student Age </h1></div>
                                                    <div ><MdClose onClick={() => setstudentAgeModal(false)} size={35} /></div>
                                                </div>
                                                <div>
                                                    <div className='flex'>
                                                        <div className='px-[20px] mt-[10px] w-full'>
                                                            <div className='text-[18px]'>
                                                                <label htmlFor="">Enter Student Age:</label>
                                                            </div>
                                                            <div>
                                                                <input value={studentAge} onChange={(e) => setstudentAge(e.target.value)} className='bg-black px-[10px] py-[5px] rounded-md text-white w-full outline-none' type="text" placeholder='Enter Student Age' />
                                                            </div>
    
                                                        </div>
                                                        <div></div>
                                                    </div>
    
                                                    <div className='flex justify-center my-[10px]'>
                                                        <button onClick={() => handleCreateStudentAge()} className='bg-[#1B1B1B] text-white px-[20px] py-[5px] font-semibold text-[15px] rounded-md'>Add</button>
                                                    </div>
                                                </div>
    
                                                {/* table start  */}
                                                <div className='w-full'>
                                                    <table className='w-full'>
                                                        <thead>
                                                            <tr className=' border-[1px] solid'>
                                                                <th>#</th>
                                                                <th>Class Name</th>
                                                                <th>Edit</th>
                                                                <th className='text-start'>Delete</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody className='w-full'>
                                                            {
                                                                getAllStudetnAge && getAllStudetnAge.map((data, index) => {
                                                                    return (
                                                                        <tr className='text-center border-[1px] solid ' key={index}>
                                                                            <td>{index + 1}</td>
                                                                            <td>{data.name}</td>
                                                                            <td className='flex justify-center'><FaEdit onClick={() => handleEditSTUAGEPop(data)} /></td>
                                                                            <td ><MdDelete onClick={(() => { HandlePOPStuAge(data._id) })} /></td>
                                                                        </tr>
                                                                    )
    
                                                                })
                                                            }
                                                            {/* <tr className='text-center border-[1px] solid'>
                                                                <td>2</td>
                                                                <td>Jacob</td>
                                                                <td className='flex justify-center'><FaEdit /></td>
                                                                <td ><MdDelete /></td>
                                                            </tr> */}
    
                                                        </tbody>
                                                    </table>
                                                </div>
                                                {/* table end  */}
    
                                            </div>
    
                                        </div>
                                    </div>
                                ) : null
                            }
    
    
                            {
                                editStudentAgeModal && editStudentAgeModal ? (
                                    <div className='inset-0 flex justify-center items-center fixed z-[50] bg-[#1c1d1f]/30' >
                                        <div className='w-[350px]'>
                                            <div className='bg-[#6C7AE0] py-[10px] px-[10px] flex justify-between'>
                                                <h5 className='text-white text-[25px]'>Edit Student Age</h5>
                                                <button onClick={() => seteditStudentAgeModal(false)}><IoMdClose size={30} color='white' /></button></div>
                                            {/* input field block start */}
                                            <div className='p-[10px] bg-white'>
    
                                                <div className='p-[5px] flex justify-between'>
                                                    <div className='w-full'>
                                                        <label htmlFor="edit_school_location">Student Age:</label>
                                                        <input id='edit_school_location' value={selectedRowData?.name}
                                                            onChange={(e) => {
                                                                const newLocationName = e.target.value
                                                                setselectedRowData((prev) => ({ ...prev, name: newLocationName }))
                                                                seteditSTUDENTaGE(newLocationName)
                                                            }
                                                            }
                                                            className='w-full p-[8px] rounded-md outline-none bg-[#121212] text-white' type="text" placeholder='Enter School Location' />
                                                    </div>
    
                                                </div>
                                                <div className=' p-[5px] flex justify-start my-[10px]'>
                                                    <button onClick={() => handleeditStudentAge(selectedRowData._id)} className='hover:bg-[#6C7AE0] bg-[#121212] px-[15px] py-[5px] text-white rounded-md' >Update</button>
                                                </div>
    
                                            </div>
                                            {/* input field block end */}
                                        </div>
                                    </div>
                                ) : null
                            }
    
    
                            {
                                deleteStuAge && deleteStuAge ? (
                                    <div className='inset-0 flex justify-center items-center fixed z-[50] bg-[#1c1d1f]/30' >
                                        <div className='w-[300px] bg-black rounded-md py-[20px]'>
                                            <div>
                                                <h4 className='text-[12px] text-white font-semibold text-center'>This Wil permanently delete this data, would you like to delete?</h4>
                                            </div>
    
    
    
                                            <div className='flex gap-6 justify-center my-[10px]'>
                                                {/* <button onClick={editCalculateUtilization} className='bg-[#1a5800] px-[15px] py-[5px] text-white rounded-md' >Calculate Total Utilization</button> */}
                                                <button onClick={() => handleDeleteStuAge(deleteStuAgeid)} className='bg-[#ec4848] px-[15px] py-[5px] text-white rounded-md' >Delete</button>
                                                <button onClick={() => setdeleteStuAge(false)} className='bg-[#1a5800] px-[15px] py-[5px] text-white rounded-md' >Cancel</button>
                                            </div>
                                        </div>
                                        {/* input field block end */}
                                    </div>
                                ) : null
                            }
    
    
                            {/* ===================student age end===========================  */}
    
    
                            {/* ==================set default start ============================= */}
                            {
                                DefaultModal && DefaultModal ? (
                                    <div>
                                        <div className='fixed inset-0 flex justify-center items-center bg-black/70'>
                                            <div className=' w-[500px] bg-white'>
                                                <div className='bg-[#8321A8] text-white flex justify-between items-center px-[10px]'>
                                                    <div> <h1 className='text-[30px] '>Set Default </h1></div>
                                                    <div ><MdClose onClick={() => setDefaultModal(false)} size={35} /></div>
                                                </div>
                                                <div>
                                                    <div className='flex justify-between items-center'>
                                                        <div className='px-[20px] mt-[10px] w-full'>
                                                            <div className='text-[18px]'>
                                                                <label htmlFor="">Select Default session:</label>
                                                            </div>
                                                            <div className='flex justify-between items-center'>
                                                                <div className='w-[70%]'>
                                                                    {/* <input value={studentAge} onChange={(e) => setstudentAge(e.target.value)} className='bg-black px-[10px] py-[5px] rounded-md text-white  outline-none w-[100%]' type="text" placeholder='Enter Student Age' /> */}
                                                                    <select value={fetcheddefaultSession} onChange={(e) => setfetcheddefaultSession(e.target.value)} className='bg-black px-[10px] py-[5px] rounded-md text-white  outline-none w-[100%]'>
                                                                        <option value="">Select Session</option>
                                                                        {
                                                                            allsessiondata && allsessiondata.map((item, index) => {
                                                                                return (
                                                                                    <option key={index} value={item.name}>{item.name}</option>
    
                                                                                )
                                                                            })
                                                                        }
                                                                    </select>
                                                                </div>
    
                                                                <div className='flex justify-center my-[10px]'>
                                                                    <button onClick={() => handleUpdateDefaultSession("66c44d078b84a11874513d8c")} className='bg-[#1B1B1B] text-white px-[20px] py-[5px] font-semibold text-[15px] rounded-md'>Update</button>
                                                                </div>
                                                            </div>
    
                                                        </div>
    
                                                    </div>
    
    
                                                </div>
    
                                                <div>
                                                    <div className='flex justify-between items-center'>
                                                        <div className='px-[20px] mt-[10px] w-full'>
                                                            <div className='text-[18px]'>
                                                                <label htmlFor="">Select Default Quarter:</label>
                                                            </div>
                                                            <div className='flex justify-between items-center'>
                                                                <div className='w-[70%]'>
                                                                    {/* <input value={studentAge} onChange={(e) => setstudentAge(e.target.value)} className='bg-black px-[10px] py-[5px] rounded-md text-white  outline-none w-[100%]' type="text" placeholder='Enter Student Age' /> */}
                                                                    <select value={fetcheddefaultQuarter} onChange={(e) => setfetcheddefaultQuarter(e.target.value)} className='bg-black px-[10px] py-[5px] rounded-md text-white  outline-none w-[100%]'>
                                                                        <option value="">Select Quarter</option>
                                                                        {
                                                                            quarterData && quarterData.map((item, index) => {
                                                                                return (
                                                                                    <option key={index} value={item.name}>{item.name}</option>
    
                                                                                )
                                                                            })
                                                                        }
                                                                    </select>
                                                                </div>
    
                                                                <div className='flex justify-center my-[10px]'>
                                                                    <button onClick={() => handleUpdateDefaultQuarter("66c454ba55b891fa6685b020")} className='bg-[#1B1B1B] text-white px-[20px] py-[5px] font-semibold text-[15px] rounded-md'>Update</button>
                                                                </div>
                                                            </div>
    
                                                        </div>
    
                                                    </div>
    
    
                                                </div>
    
                                            </div>
    
                                        </div>
                                    </div>
                                ) : null
                            }
                            {/* ==================set default end ============================= */}
    
    
    
    
    
    
                            {/* ===================rubric image start============================  */}
                            {
                                showRubric && showRubric ? (
                                    <div>
                                        <div className='fixed inset-0 flex justify-center items-center bg-black/70'>
                                            <div className=' w-[70%] bg-white'>
                                                <div className='bg-[#8321A8] text-white flex justify-between items-center px-[10px]'>
                                                    <div> <h1 className='text-[30px] '>Rubric </h1></div>
                                                    <div ><MdClose onClick={() => setShowRubric(false)} size={35} /></div>
                                                </div>
                                                <div>
                                                    <div className='flex justify-center items-center'>
                                                        <img src={Lexile_rubric} alt="Lexile rubric image" />
    
                                                    </div>
                                                </div>
    
                                            </div>
    
                                        </div>
                                    </div>
                                ) : null
                            }
    
                            {/* ===================rubric image end============================  */}
    
    
                        </div>
                    </div>
                </div>
                 ):(
                    <>
                    <p>You are not Authorized.</p>
                    </>
                )
            }  
          
        </div>
    )
}

export default Masters